// src/components/Layout.tsx
import { Link, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import useAuth from "../context/AuthContext";
import Sidebar from "./Sidebar";

export default function Layout() {
  const { user, isAuthenticated, logout } = useAuth();

  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  


  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Right Side Content */}
      <div
        style={{
          flex: 1,
          marginLeft: isMobile ? 0 : 240,
          transition: "margin-left 0.3s ease",
          width: "100%",
        }}
      >
        <header
          style={{
            padding: "12px 20px",
            background: "var(--header-bg)",
            borderBottom: "1px solid var(--border)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <nav>
            <Link to="/clients" style={{ marginRight: 12 }}>
              Clients
            </Link>
            <Link to="/engagements">Engagements</Link>
          </nav>

          <div>
            {isAuthenticated ? (
              <>
                <span style={{ marginRight: 12, fontWeight: "bold" }}>
                  {user?.name || user?.email || "User"}
                </span>
                <button
                  onClick={() => logout()}
                  style={{
                    padding: "6px 10px",
                    cursor: "pointer",
                  }}
                >
                  Logout
                </button>
              </>
            ) : (
              <Link to="/login">Login</Link>
            )}
          </div>
        </header>

        <main style={{ padding: 20 }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}